import { SAVE_CHAT_ANSWERS, SAVE_PROPOSAL } from './mutation-types';

export default {
    [SAVE_CHAT_ANSWERS](state, answers) {
        state.answers = answers;
    },
    [SAVE_PROPOSAL](state, proposal) {
        state.proposal = proposal;
    },
};
